import { css } from '@emotion/react';

const SCROLL_WIDTH = 14;

export const SCROLL = css`
  ::-webkit-scrollbar {
    width: ${SCROLL_WIDTH}px;
    height: ${SCROLL_WIDTH}px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgb(43, 43, 54);
    border-radius: 10px;
    border: solid 2px rgb(63, 63, 79);
  }

  ::-webkit-scrollbar-corner {
    background: transparent;
  }
`;
